import { BoxContainer, GenderContainer } from "app/pages/website-analysis/demographics/StyledComponents";
import { GenderDistributionPieChart } from "app/pages/website-analysis/demographics/GenderDistributionPieChart/GenderDistributionPieChart";
import type { FC } from "react";

interface IGenderDistribution {
    femalesRatio: number;
    isLoading: boolean;
    downloadExcelUrl: string;
}

export const GenderDistribution: FC<IGenderDistribution> = (props) => {
    const { femalesRatio, isLoading, downloadExcelUrl } = props;
    const femalePercent = femalesRatio * 100;
    const malePercent = 100 - femalePercent;
    return (
        <GenderContainer>
            <BoxContainer>
                <GenderDistributionPieChart
                    malePercent={malePercent}
                    femalePercent={femalePercent}
                    isLoading={isLoading}
                    downloadExcelUrl={downloadExcelUrl}
                />
            </BoxContainer>
        </GenderContainer>
    );
};
